import { jsx as _jsx } from "react/jsx-runtime";
import { RouterManager } from "./routes/RouterManager";
export function App() {
    return _jsx(RouterManager, {});
}
